export default {
  play(state, { oid }) {
    const { playState } = state
    const curOid = playState.oid
    if (curOid === oid) {
      state.playState = {
        ...playState,
        playing: !playState.playing
      }
    } else {
      state.curOid = oid
      state.playState = {
        oid,
        time: 0,
        duration: 60,
        playing: true
      }
    }
  },

  playUpdate(state, args) {
    const { playState } = state
    if (args && playState.oid === args.oid) {
      state.playState = { ...playState, ...args }
    }
  }
}
